export function setAccordionCrossClasses(accordionElement, isOpen) {
	let crossOne = accordionElement.querySelector('.cross-p-1');
	let crossTwo = accordionElement.querySelector('.cross-p-2');

	if (crossOne && crossTwo) {
		if (isOpen) {
			crossOne.classList.add('rotate-180');
			crossTwo.classList.add('opacity-0');
			crossTwo.classList.add('rotate-90');
		} else {
			crossOne.classList.remove('rotate-180');
			crossTwo.classList.remove('opacity-0');
			crossTwo.classList.remove('rotate-90');
		}
	}
}